import moment from 'moment';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'momentStartDay'
})
export class MomentStartDayPipe implements PipeTransform {
    transform(date: string): string {
        return moment(date).startOf('day').toISOString(true);
    }
}
